const Frisbee = require('frisbee');

// LOCAL DEV
//const apiBaseUrl = 'https://localhost:5033/api/';     // visual studio for windows
//const apiBaseUrl = 'http://localhost:5032/api/';      // visual studio for mac

// PREMIER AWS TEST BED
//const apiBaseUrl = 'https://qlnh5yehvllzgkizidvgb23rke0mxnef.lambda-url.us-east-1.on.aws/api/';

// PREMIER AWS PROD
const apiBaseUrl = 'https://r3grwkviy6vs4xxt3usudqs24q0wvlcg.lambda-url.us-east-1.on.aws/api/';

const api = new Frisbee({
  baseURI: apiBaseUrl,   
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  mode: 'cors',
});

api.interceptor.register({
  response: (response) => {
    if (response.status !== 200) {
      return Promise.reject(response.status);
    }
    return response;
  }
});

export const login = async (growerId, emailAddress, growerIdOverride, emailAddressOverride, bypassEmailValidation) => {
  const response = await api.post('Auth/Login', {
    body: {
      growerId: growerId,
      emailAddress: emailAddress,
      growerIdOverride: growerIdOverride,
      emailAddressOverride: emailAddressOverride,
      bypassEmailValidation: bypassEmailValidation !== undefined && bypassEmailValidation !== null && bypassEmailValidation === '1' ? true : false,
    }
  });
  if (response.body.isAuthorizedUser === true) {
    api.jwt(response.body.token);
  }
  return response.body;
}

export const getWeatherStations = async () => {
  return await api.post('WeatherLink/GetWeatherStations');
}

export const getWeatherStationsByGeolocation = async (latitude, longitude) => {
  return await api.post('WeatherLink/GetWeatherStationsByGeolocation', {
    body: {
      latitude,
      longitude,
    }
  });
}

/*
export const getWeatherStationSensorData = async (weatherStation) => {
  return await api.post('WeatherLink/GetWeatherStationSensorData', {
    body: {
      weatherStation: weatherStation,
    }
  });
}
*/

export const getWeatherStationHistoricalData = async (weatherStation, startDate, endDate) => {
  return await api.post('WeatherLink/GetWeatherStationHistoricalData', {
    body: {
      weatherStation: weatherStation,
      startDate: startDate,
      endDate: endDate,
    }
  });
}

export const getCashBidLocations = async (commodityFilter, monthFilter, showAllLocations) => {
  return await api.post('CashBids/GetCashBidLocations', {
    body: {
      commodityFilter: commodityFilter,
      monthFilter: monthFilter,
      showAllLocations: showAllLocations,
    }
  });
}

export const getCashBidLocation = async (locationId) => {
  return await api.post('CashBids/GetCashBidLocation', {
    body: {
      locationId: locationId,
    }
  });
}

export const getCashBidLocationsWithoutFutures = async (showAllLocations) => {
  return await api.post('CashBids/GetCashBidLocationsWithoutFutures', {
    body: {
      showAllLocations: showAllLocations,
    }
  });
}

export const getCashBidLocationNearByHistory = async (basisRollingSymbol, cashPriceRollingSymbol, startDate, endDate) => {
  return await api.post('CashBids/GetCashBidLocationNearByHistory', {
    body: {
      basisRollingSymbol: basisRollingSymbol,
      cashPriceRollingSymbol: cashPriceRollingSymbol,
      startDate: startDate,
      endDate: endDate,
    }
  });
}

export const getTableauToken = async (emailAddress) => {
  return await api.post('Tableau/GetTableauToken', {
    body: {
      emailAddress: emailAddress,
    }
  });
}

export const getCurrentCropYear = async () => {
  return await api.post('Customer/GetCurrentCropYear');
}

export const getCropYears = async () => {
  return await api.post('Customer/GetCropYears');
}

export const getCommodities = async () => {
  return await api.post('Customer/GetCommodities');
}

export const getCommoditiesForCropYear = async (growerId, cropYear) => {
  return await api.post('Customer/GetCommoditiesForCropYear', {
    body: {
      growerId: growerId,
      cropYear: cropYear,
    }
  });
}

export const getCustomerFarmFields = async (growerId, getMappedFields, cropYear = null, commodity = null) => {
  return await api.post('Customer/GetCustomerFarmFields', {
    body: {
      growerId: growerId,
      getMappedFields: getMappedFields,
      cropYear: cropYear,
      commodity: commodity,
      radius: 5,
    }
  });
}

export const getCustomerFarmFieldsWithNutrientRemoval = async (growerId) => {
  return await api.post('Customer/GetCustomerFarmFieldsWithNutrientRemoval', {
    body: {
      growerId: growerId,
    }
  });
}

export const getDigiFarmFields = async (minLongitude, minLatitude, maxLongitude, maxLatitude) => {
  return await api.post('DigiFarm/GetDigiFarmFields', {
    body: {
      minLongitude: minLongitude,
      minLatitude: minLatitude,
      maxLongitude: maxLongitude,
      maxLatitude: maxLatitude,
    }
  });
}

export const getHiResDigiFarmFields = async (farmFields) => {
  return await api.post('DigiFarm/GetHiResDigiFarmFields', {
    body: {
      farmFields: farmFields,
    }
  });
}

export const emailCustomerFarmFieldMapping = async (agvanceUser, userIpAddress, farmField, base64ScreenCapture, mapCenterLatitude, mapCenterLongitude, digiFields) => {
  return await api.post('Customer/EmailCustomerFarmFieldMapping', {
    body: {
      agvanceUser: agvanceUser,
      userIpAddress: userIpAddress,
      farmField: farmField,
      base64ScreenCapture: base64ScreenCapture,
      mapCenterLatitude: mapCenterLatitude,
      mapCenterLongitude: mapCenterLongitude,
      digiFields: digiFields,
    }
  });
}

export const emailCustomerFarmFieldMappingWithUserDrawing = async (agvanceUser, userIpAddress, farmField, base64ScreenCapture, userDrawnShapes, mapCenterLatitude, mapCenterLongitude) => {
  return await api.post('Customer/EmailCustomerFarmFieldMappingWithUserDrawing', {
    body: {
      agvanceUser: agvanceUser,
      userIpAddress: userIpAddress,
      farmField: farmField,
      base64ScreenCapture: base64ScreenCapture,
      userDrawnShapes: userDrawnShapes,
      mapCenterLatitude: mapCenterLatitude,
      mapCenterLongitude: mapCenterLongitude,
    }
  });
}

export const createPurchaseContract = async (agvanceUser, emailAddress, purchaseContractType, purchaseContractCashBid, purchaseContractLocation, purchaseContractFutures, purchaseContractNumberOfBushels, purchaseContractSettleGrain, purchaseContractSettleGrainPaymentType, purchaseContractComments, purchaseContractHTAFee, purchaseContractPrice, purchaseContractApplyToExistingContract, purchaseContractExistingContractNumber, userIpAddress) => {
  return await api.post('Customer/CreatePurchaseContract', {
    body: {
      agvanceUser,
      emailAddress,
      purchaseContractType,
      purchaseContractCashBid,
      purchaseContractLocation,
      purchaseContractFutures,
      purchaseContractNumberOfBushels,
      purchaseContractSettleGrain,
      purchaseContractSettleGrainPaymentType,
      purchaseContractComments,
      purchaseContractHTAFee,
      purchaseContractPrice,
      purchaseContractApplyToExistingContract,
      purchaseContractExistingContractNumber,
      userIpAddress,
    }
  });
}

export const createOffer = async (agvanceUser, emailAddress, cashBid, location, cashPrice, bushels, expirationDate, comments, userIpAddress) => {
  return await api.post('Customer/CreateOffer', {
    body: {
      agvanceUser: agvanceUser,
      emailAddress: emailAddress,
      cashBid: cashBid,
      location: location,
      cashPrice: cashPrice,
      bushels: bushels,
      expirationDate: expirationDate,
      comments: comments,
      userIpAddress: userIpAddress,
    }
  });
}

export const getOffers = async (agvanceUser, emailAddress) => {
  return await api.post('Customer/GetOffers', {
    body: {
      agvanceUser: agvanceUser,
      emailAddress: emailAddress,
    }
  });
}

export const cancelOffer = async (agvanceUser, emailAddress, offerId) => {
  return await api.post('Customer/CancelOffer', {
    body: {
      agvanceUser: agvanceUser,
      emailAddress: emailAddress,
      offerId: offerId,
    }
  });
}

export const getCustomerFarmFieldsList = async (growerId) => {
  return await api.post('Customer/GetCustomerFarmFieldsList', {
    body: {
      growerId: growerId,
    }
  });
}

export const getNetOfFreightLocations = async (longitude, latitude, commodity) => {
  return await api.post('Customer/GetNetOfFreightLocations', {
    body: {
      longitude: longitude,
      latitude: latitude,
      commodity: commodity,
    }
  });
}

export const getHedgingActiveStatus = async () => {
  return await api.post('CashBids/GetHedgingActiveStatus');
}

export const getHistoricalWeatherStationAverages = async (weatherStationId, year) => {
  return await api.post('WeatherLink/GetHistoricalWeatherStationAverages', {
    body: {
      weatherStationId: weatherStationId,
      year: year,
    }
  });
}

export const getHTAFees = async () => {
  return await api.post('Customer/GetHTAFees');
}

export const saveCropTour = async (latitude, longitude, growerId, emailAddress, plantPopulation, kernelsPerBushel, ears, calculatedYield, token) => {
  api.jwt(token);
  return await api.post('Customer/SaveCropTour', {
    body: {
      latitude,
      longitude,
      growerId,
      emailAddress,
      plantPopulation,
      kernelsPerBushel,
      ear1Length: ears[0].length,
      ear1Rows: ears[0].rows,
      ear2Length: ears[1].length,
      ear2Rows: ears[1].rows,
      ear3Length: ears[2].length,
      ear3Rows: ears[2].rows,
      ear4Length: ears[3].length,
      ear4Rows: ears[3].rows,
      calculatedYield,
    }
  });
}


export const uploadCropTourFile = async (file, cropTourId, token) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('cropTourId', cropTourId);
  return await fetch(apiBaseUrl + 'Customer/UploadCropTourFile', {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token, 
    },
    body: formData,
  });
}

export const emailWeatherStationIssue = async (customerName, weatherStationName, weatherStationIssue) => {
  return await api.post('Customer/EmailWeatherStationIssue', {
    body: {
      customerName: customerName,
      weatherStationName: weatherStationName,
      weatherStationIssue: weatherStationIssue,
    }
  });
}

export const getAllCustomerFarmFields = async (growerId, cropYear) => {
  return await api.post('Customer/GetAllCustomerFarmFields', {
    body: {
      growerId: growerId,
      cropYear: cropYear,
    }
  });
}

export const saveCarbonScoringAnswers = async (payload) => {
  return await api.post('Customer/SaveCarbonScoringAnswers', {
    body: payload
  });
}

export const getCarbonScoringAnswers = async (growerId, cropYear, fieldGUID) => {
  return await api.post('Customer/GetCarbonScoringAnswers', {
    body: {
      growerID: growerId,
      cropYear: cropYear,
      fieldGUID: fieldGUID,
    }
  });
}

export const getContangoEmbedToken = async (growerId) => {
  return await api.post('Contango/GetEmbedToken', {
    body: {
      growerId: growerId,
    }
  });
}
